/** @format */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, of } from 'rxjs';
import { switchMap, take, map, first } from 'rxjs/operators';
import { DbService } from './db.service';
import * as firebase from 'firebase/app';
import { AlertService } from './alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$: Observable<any>;
  userVeriFy = false;
  public isTab = true;
  constructor(
    public afAuth: AngularFireAuth,
    public db: DbService,
    public router: Router,
    public alert: AlertService,
    private modalService: NgbModal
  ) {
    this.user$ = this.afAuth.authState.pipe(switchMap(user => (user ? db.doc$(`users/${user.uid}`) : of(null))));

    this.user$.subscribe(data => {
      if (data) {
        localStorage.setItem('userId', data.id);
      }
    });
  }

  getUser(): any {
    return this.user$.pipe(first()).toPromise();
  }

  uid(): any {
    return this.user$
      .pipe(
        take(1),
        map(u => u && u.id)
      )
      .toPromise();
  }

  approval(): any {
    return this.user$
      .pipe(
        take(1),
        map(u => u && u.activeSwitch)
      )
      .toPromise();
  }

  userId(): any {
    return this.user$.pipe(
      take(1),
      map(u => u.id)
    );
  }

  reload(): any {
    firebase.default
      .auth()
      .currentUser.reload()
      .then(() => {
        console.log(firebase.default.auth().currentUser);
      });
  }

  info(): any {
    return this.user$.pipe(take(1)).toPromise();
  }

  infoR(): any {
    return this.user$
      .pipe(
        take(1),
        map(u => u && u.selectedParts)
      )
      .toPromise();
  }

  async anonymousLogin(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      firebase.default
        .auth()
        .signInAnonymously()
        .then(
          res => resolve(res),
          err => reject(err)
        );
    });
  }

  async emailLogin(obj): Promise<any> {
    try {
      var r = await this.afAuth.signInWithEmailAndPassword(obj.email, obj.password);
      if (r) {
        const user = r.user;
        if (user.emailVerified) {
          localStorage.setItem('userId', r.user.uid);
          // this.navc.navigateRoot('/');
          // this.load.hide();
          // this.alertService.presentToast('로그인 하였습니다.');
        }
      }
    } catch (error) {
      const code = error['code'];
    }
  }

  loginUser(value): any {
    return new Promise<any>((resolve, reject) => {
      firebase.default
        .auth()
        .signInWithEmailAndPassword(value.email, value.password)
        .then(
          res => resolve(res),
          err => reject(err)
        )
        .catch(err => reject(err));
    });
  }

  exitLogin(obj): any {
    return new Promise<any>((resolve, reject) => {
      try {
        var r = this.afAuth.signInWithEmailAndPassword(obj.email, obj.password);

        if (r) {
        }
      } catch (error) {
        let code = error['code'];

        resolve(error);
      }
    });
  }
  loginWithToken(token): any {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise<any>((resolve, reject) => {
      firebase.default
        .auth()
        .signInWithCustomToken(token)
        .then(
          res => resolve(res),
          err => reject(err)
        );
    });
  }

  resetPassword(email): any {
    this.afAuth
      .sendPasswordResetEmail(email)
      .then(() => {})
      .catch(err => {});
  }

  async signOut(): Promise<any> {
    await this.afAuth.signOut();
    return this.router.navigate(['/']);
  }

  registerUser(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase.default
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(res => {
          localStorage.setItem('userId', res.user.uid);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  setRedirect(val): any {
    localStorage.setItem('authRedirect', val);
  }

  isRedirect(): any {
    return localStorage.getItem('authRedirect');
  }

  changePassword(value) {
    return new Promise((resulve, reject) => {
      this.afAuth.currentUser
        .then(user => {
          user
            .updatePassword(value)
            .then(e => {
              resulve(e);
            })
            .catch(err => {
              reject(err);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  exitUser(): any {
    return new Promise((resolve, reject) => {
      const user = firebase.default.auth().currentUser;
      console.log(user, user.uid);

      this.db
        .updateAt(`users/${user.uid}`, { exitSwitch: true, exitDate: new Date().toISOString() })
        .then(() => {
          user
            .delete()
            .then(() => {
              // const key = localStorage.getItem('keywords')
              // localStorage.clear();
              // localStorage.setItem('keywords')
              // this.router.navigateByUrl('/login');
              resolve(true);
            })
            .catch(error => {});
        })
        .catch(error => {
          console.log(error, 'durl????');
        })
        .catch(error => {
          console.log(error, 'hnihihihihi');
        });
    });
  }

  async sendEmailVerificationUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (firebase.default.auth().currentUser) {
        firebase.default
          .auth()
          .currentUser.sendEmailVerification()
          .then(res => {
            console.log('rr', res);
            this.emailVerified();

            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  }

  emailVerified() {
    return this.afAuth.authState
      .pipe(
        take(1),
        map(u => u && u.emailVerified)
      )
      .toPromise();
  }

  emailcehck() {
    this.afAuth.authState.subscribe(data => {
      if (data.emailVerified) {
        this.db.updateAt(`users/${data.uid}`, {
          emailVerify: true,
        });
      }
      console.log(data);
    });
  }

  userDetails(): any {
    return firebase.default.auth().currentUser;
  }

  logoutUser(): any {
    return new Promise((resolve, reject) => {
      const user = firebase.default.auth().currentUser;
      if (firebase.default.auth().currentUser) {
        firebase.default
          .auth()
          .signOut()
          .then(res => {
            console.log('여긱까자와');
            localStorage.clear();
            this.db.updateAt(`users/${user.uid}`, { pushId: '', alarmSwitch: true }).then(res => {
              resolve(res);
            });
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  }

  //클로즈 이메일
  async updateEmailClosed(email, id, date) {
    return new Promise((resolve, reject) => {
      const user = firebase.default.auth().currentUser;
      let data = { dateClosed: date, email: email };
      this.db
        .updateAt(`EmailClosed/${user.uid}`, data)
        .then(success => {
          resolve(true);
        })
        .catch(error => {
          reject(false);
        });
    });
  }

  // 메일 발송
  sendPasswordReset(email: string) {
    // return new Promise((resolve, reject) => {
    return firebase.default
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        return this.alert.successmsg(`<a>${email}</a>로<br>비밀번호 재설정 메일이 발송되었습니다.`, '비밀번호 재설정');
      })
      .catch(error => {
        let code = error['code'];
        if (code === 'auth/user-not-found' || 'auth/invalid-email') {
          this.alert.successmsg('가입된 이메일 주소가 아닙니다.<br>확인 후 다시 입력해주세요.', '계정 없음');
        }
      });
    // })
  }
}
